import * as React from 'react';
import cx from 'classnames';
import Collapse from '@mui/material/Collapse';
import Cell from '@mui/material/TableCell';
import Row from '@mui/material/TableRow';
import get from 'lodash/get';
import Checkbox from '@mui/material/Checkbox';

const styles = {
  containerRow: {
    '& td.MuiTableCell-root': {
      'borderBottom': 'unset',
      '&:first-of-type': {
        borderBottomLeftRadius: 0,
      },
      '&:last-of-type': {
        borderBottomRightRadius: 0,
      },
    },
  },
  childFirstRow: {
    '& td.MuiTableCell-root': {
      'borderTop': 0,
      'borderBottom': 0,
      '&:last-of-type': {
        borderRadius: 0,
      },
    },
    '& td.MuiTableCell-root:first-of-type': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  childLastRow: {
    '& td.MuiTableCell-root': {
      'borderTop': 0,
      '&:first-of-type': {
        borderTopLeftRadius: 0,
      },
      '&:last-of-type': {
        borderTopRightRadius: 0,
      },
    },
  },
  childRow: {
    '& td.MuiTableCell-root': {
      '&:first-child': {
        borderRadius: 0,
      },
      '&:last-child': {
        borderRadius: 0,
      },
    },
  },
};

const TableRow = ({
  row,
  index,
  keyField,
  renderChildren,
  handleClick,
  columns = [],
  selectable,
  isItemSelected,
  handleCheckBox,
  isChild,
  isFirst,
  isLast,
  sx = {},
  ...props
}) => {
  const childElement = renderChildren ? renderChildren(row) : undefined;

  return (
    <>
      {!isChild && <tr className="spacer" style={{ height: 10 }} />}
      <Row
        {...props}
        onClick={handleClick}
        sx={{
          ...sx,
          '& > *': { cursor: handleClick && 'pointer' },
          ...(isFirst ? styles.childFirstRow : {}),
          ...(childElement ? styles.containerRow : {}),
          ...(isLast ? styles.childLastRow : {}),
          ...(isChild && !isChild && !isLast ? styles.childRow : {}),
        }}
        className={cx({
          'child-row': isChild,
          'child-row--first': isFirst,
          'child-row--last': isLast,
        })}
      >
        {selectable && (
          <Cell padding="checkbox">
            <Checkbox
              color="primary"
              checked={isItemSelected}
              onClick={(e) => e.stopPropagation()}
              onChange={handleCheckBox}
            />
          </Cell>
        )}
        {columns.map((col, idx) => (
          <Cell
            key={`${get(row, keyField)}${col.dataField}${col.keyField || idx}`}
            align={col.numeric ? 'right' : col.align}
            sx={col.sx}
          >
            {col.formatter
              ? col.formatter(
                  get(row, col.dataField),
                  row,
                  index,
                  col.formatExtraData,
                )
              : get(row, col.dataField)}
          </Cell>
        ))}
      </Row>
      {childElement &&
        Array.isArray(childElement) &&
        childElement.map((c, idx) =>
          React.cloneElement(c, {
            isChild: true,
            isFirst: idx === 0,
            isLast: idx === childElement.length - 1,
          }),
        )}
    </>
  );
};

export default TableRow;
